/* eslint-disable node/no-callback-literal */
import { AUTH } from 'constants/api'
import { useContext } from "react"
import { useHistory } from 'react-router-dom'
import { AuthError, FacebookAuthProvider, getAuth, OAuthCredential, signInWithPopup } from '@firebase/auth'
import axios, { AxiosError } from 'axios'
import useRedirect from 'hooks/use-redirect'
import utmServices from 'services/utm-services'
import FacebookIcon from 'components/icon/facebook'
import ProfileService from 'services/profile-services'
import { UserData } from 'contexts/session-context/session-reducer'
import { LoaderContext } from '../../../contexts/loader-context'

function Facebook({ setSession, setUser, setLoginError, setError, setFirebaseError, setAllowCookies }) {

  const { setLoad } = useContext(LoaderContext)
  const [{ url }, { redirect }] = useRedirect();
  const auth = getAuth()
  const provider = new FacebookAuthProvider()
  const history = useHistory()

  const completeData = (user: UserData, session: Object) => {
    setSession(session)
    setUser(user)
    const { nickName, birthday, genre, genreId } = user
    if (!nickName || !birthday || (!genre || !genreId)) {
      return history.push('/information/update?isNew=true')
    } else if (url) {
      return redirect()
    } else {
      history.push('/home')
    }
  }

  const callback = async (data?: { termsOfUse?: boolean, subscribe?: boolean, code?: string, session: Object, user: UserData }) => {
    setLoad(true)
    const { session, user, termsOfUse, subscribe, code } = data || {}
    try {
      if (termsOfUse || subscribe || code) {
        const response = await ProfileService.socialLogin({ payload: { termsOfUse, subscribe, code }, credentials: session })
        return completeData(response?.data, session)
      }
      return completeData(user, session)
    } catch (error) {
      setAllowCookies({ callback, isAllow: false })
      const code = (error as AxiosError).response?.data.code || 99999
      setLoginError(code)
    } finally {
      setLoad(false)
    }
  }


  const handleOnClick = async () => {
    gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'Click - Meta', value: 'Meta' })
    setLoad(true)
    try {
      provider.addScope('user_likes')
      provider.addScope('user_birthday')
      provider.addScope('email')
      const result = await signInWithPopup(auth, provider)
      if (!result?.user?.email) {
        return setFirebaseError('auth/email-not-exist')
      }
      const names = result.user?.displayName?.split(' ') || ['', '']
      const firstName = names[0]
      const lastName = names[names.length - 1]
      const { accessToken } = FacebookAuthProvider.credentialFromResult(result) as OAuthCredential

      const utm = utmServices.utmRead()
      const loginResponse = await axios.post(
        AUTH,
        {
          accessToken,
          firstName,
          lastName,
          utm
        },
        {
          headers: { Authorization: `Bearer ${(result.user as any).accessToken}` }
        }
      )
      setLoad(false)
      if (!loginResponse.data?.termsOfUse) {
        gtag('event', 'sign_up', {
          event_label: 'SignUp - Meta',
          method: "Meta"
        })
        return setAllowCookies({ callback: (data: { termsOfUse: boolean, subscribe: boolean, code?: string }) => callback({ ...data, session: result, user: loginResponse.data }), isAllow: true })
      }
      gtag("event", "login", {
        event_label: 'Login - Meta',
        method: "Meta"
      });
      callback({ session: result, user: loginResponse.data })
    } catch (error) {
      if ((error as AxiosError).isAxiosError) {
        const code = (error as AxiosError).response?.data.code || 99999
        setLoginError(code)
      } else {
        const typedError = error as AuthError
        setError(typedError)
        setFirebaseError(typedError.code)
      }
    } finally {
      setLoad(false)
    }
  }

  return (
    <div onClick={handleOnClick} className="cursor-pointer">
      <FacebookIcon />
    </div>
  )
}

export default Facebook
